/* eslint-disable @typescript-eslint/no-namespace */
export namespace InternalTracking {
  export enum MetricsStatus {
    Interested,
    InProgress,
    Approved,
    NotApproved,
  }

  export function statusMapper({
    internalStatusInterested,
    internalStatusNotApproved,
    internalStatusInProgress,
    internalStatusApproved,
  }) {
    return [
      {
        id: ' - ',
        text: ' - ',
        disabled: false,
      },
      {
        id: MetricsStatus[MetricsStatus.Interested],
        text: 'Interested',
        disabled: !internalStatusInterested,
      },
      {
        id: MetricsStatus[MetricsStatus.InProgress],
        text: 'In Progress',
        disabled: !internalStatusInProgress,
      },
      {
        id: MetricsStatus[MetricsStatus.Approved],
        text: 'Approved',
        disabled: !internalStatusApproved,
      },
      {
        id: MetricsStatus[MetricsStatus.NotApproved],
        text: 'Not Approved',
        disabled: !internalStatusNotApproved,
      },
    ];
  }

  export const ownershipOptions = [
    { text: ' - ', id: ' - ' },
    { text: 'Yes', id: 'Yes' },
    { text: 'No', id: 'No' },
  ];
  export const ratingOptions = [
    { text: ' - ', id: ' - ' },
    { text: 'AAA', id: 'AAA' },
    { text: 'AA+', id: 'AA+' },
    { text: 'AA', id: 'AA' },
    { text: 'AA-', id: 'AA-' },
    { text: 'A+', id: 'A+' },
    { text: 'A', id: 'A' },
    { text: 'A-', id: 'A-' },
    { text: 'BBB+', id: 'BBB+' },
    { text: 'BBB', id: 'BBB' },
    { text: 'BBB-', id: 'BBB-' },
    { text: 'BB+', id: 'BB+' },
    { text: 'BB', id: 'BB' },
    { text: 'BB-', id: 'BB-' },
    { text: 'B+', id: 'B+' },
    { text: 'B', id: 'B' },
    { text: 'B-', id: 'B-' },
    { text: 'CCC+', id: 'CCC+' },
    { text: 'CCC', id: 'CCC' },
    { text: 'CCC-', id: 'CCC-' },
    { text: 'CC', id: 'CC' },
    { text: 'C', id: 'C' },
    { text: 'D', id: 'D' },
  ];
}
